export default {
  methods: {
    resolveTokenLogoUrl(tokenName) {
      return require(`@/assets/tokens/${tokenName}_token.svg`)
    },
  },
}
